import { useMemo } from 'react';
import { useOgConsolidationUserState } from '@jira/eoc__changeboarding/src/controllers/use-og-consolidation-user-state/index.tsx';
import { shouldRenderBenefitModal } from '@jira/eoc__changeboarding/src/ui/benefit-modal/utils.tsx';
import { useOgTenantInfo } from '@jira/eoc__tenant-info/src/controllers/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { BANNER_NAME, HEIGHT } from './bannerName.constants.tsx';

export const useBannerEocTransition = (): {
	isEnabled: boolean;
	name: 'EOC_TRANSITION';
	height: number;
} => {
	const { data, error } = useOgConsolidationUserState();
	const isAdmin = useIsAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const { isTransitionEligible, error: tenantInfoError } = useOgTenantInfo();

	const isEnabled = Boolean(
		(isAdmin || isSiteAdmin) &&
		// Tenant info
		!tenantInfoError &&
		isTransitionEligible &&
		// User state
		!error &&
		data &&
		(!data.isTransitionBannerDismissed ||
			shouldRenderBenefitModal({
				bannerDismissedAt: data.transitionBannerDismissedAt,
				isDismissed: data.isBenefitModalDismissed,
			})),
	);

	return useMemo(
		() => ({
			isEnabled,
			name: BANNER_NAME,
			height:
				data && shouldRenderBenefitModal({ bannerDismissedAt: data.transitionBannerDismissedAt })
					? 0
					: HEIGHT,
		}),
		[data, isEnabled],
	);
};
